/**
 * 全部资源
 * created by yxy
 *
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import BaseComponent from "../../../../base/BaseComponent";
import {Table, Input, Checkbox, Button, Select, Radio, Upload, Pagination, Modal} from "antd";
import {formatTime} from '../../../../utils'
import {message} from '../../components/Mess'
// import InputNumber from "../../../businessCenter/components/InputNumber";
import {Scrollbars} from "react-custom-scrollbars";
import PageTableComponent from "../../components/pageTable/PageTable";
import {HEADER_HEIGHT} from "../../../../constants";
import CmForm from "../../../../components/CmForm/CmForm";
import CandidateComponents from "../../../components/treeModuleBySelectPerson/CandidateComponents";
import {uuid} from "../../../../utils";
import $ from "jquery";
const { Option } = Select;
const { Search } = Input;

export default class Authorization extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {

        super(props);
        this.state = {
            page: 1,
            size: 10,
            data: [],
            count: 0,
            deptName:'',
            management:false,
            peopleList:[],
            departName:'',
            currentObj:{},
            candidateComponentsKey:uuid()

        }
    }

    componentWillMount() {

    }
    componentDidMount() {
        this.getList();
    }
    render() {

        return (
            <div style={{background: '#ffffff',
                padding: '24px 32px 16px 32px',
                margin: "15px 0 15px 15px",
                position: 'relative',
                borderRadius:5}}>
                {/*渲染选择框以及下载 功能*/}
                {this.renderBtn()}
                {/*渲染数据*/}
                {this.renderData()}
                {/*选人弹窗*/}
                {this.renderModel()}
            </div>
        )
    }
    renderModel=()=>{

        let deptId = (this.state.currentObj && this.state.currentObj.deptId) || 0;
        return (
            <Modal
                maskClosable={false}
                keyboard={true}
                title="设置单位管理员"
                visible={this.state.management}
                centered
                key={uuid()}
                width={800}
                onOk={()=>{
                    this.setupAdministrator()
                }}
                onCancel={()=>{
                    // this.CandidateComponents.setTimeout = null;
                    // clearTimeout(this.CandidateComponents.myTimeout);
                    this.setState({management:false,candidateComponentsKey:uuid()})
                }}
            >
                    <div style={{display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',}}>
                        <CandidateComponents key={this.state.candidateComponentsKey} deptId={deptId.toString()}  type={'onlyThisDeptPerson'} ref={(CandidateComponents)=>{this.CandidateComponents=CandidateComponents}} />
                        {/*<Button type="primary" >确定</Button>*/}
                    </div>
            </Modal>
        )
    }
    renderBtn() {
        return (
                <div  style={{display:'flex'}}>
                    <Search
                        allowClear={true}
                       placeholder="请输入关键字"
                        onSearch={value => {
                       this.setState({deptName: value,page:1}, () => {
                         this.getList()
                       })
                      }}
                       style={{width: 224,marginRight:20}}

                       />
                    <div style={{width:"15%",marginRight:20}}>
                        <Select defaultValue="全部" style={{ width: '100%'}}   onChange={(value) => this.handleChange(value)}>
                            <Option value="全部">全部</Option>
                            <Option value= '未设置管理员'>未设置管理员</Option>
                            <Option value= "已设置管理员">已设置管理员</Option>
                        </Select>
                    </div>
                    <div style={{marginRight:20}}>
                        <Upload accept={".xlsx,.xls"}
                                showUploadList={false}
                                customRequest={({file}) => {
                                    let url = "/cm-sites-storage-management/zykManage/importManager";
                                    let fd = new FormData();
                                    fd.append("file", file);
                                    this.request({url, body: fd, method: "post", contentType: "upload", callBack: (data) => {
                                            if(data) {
                                                message.success("批量导入成功");
                                                this.getList()
                                            } else {
                                                message.error("批量导入失败！");
                                            }
                                        },
                                    });
                                }}
                        >
                            <Button type="primary">批量导入管理员</Button>
                        </Upload>
                    </div>
                    <div style={{marginRight:20}}>
                        <Button style={{marginLeft:"1%"}} onClick={()=>this.BatchImport()}>导入模板下载</Button>
                    </div>
                </div>
        )
    }
    setupAdministrator(){
        this.CandidateComponents.getSelectList((selectList)=>{
            let id= []; let name = [];
            selectList&&selectList.length&&selectList.forEach((item,index)=>{
                id.push(item.id);
                name.push(item.name)
            });
            let deptName= window.currentUser.deptList;
            let array = [];
            deptName&&deptName.length&&deptName.forEach((item,index)=>{
                array.push(item.name)
            });
                let parms={
                    deptId:window.currentUser.deptIds[0],
                    deptName:array.join(','),
                    deptManageAccountList:id,
                    deptManageNameList:name,
                    id:this.state.currentId
                };
                this.request({
                    url: "/cm-sites-storage-management/zykManage/upsertZykManager",
                    method: "post",
                    body:parms,
                    contentType: "json",
                    callBack: (data) => {
                        if(data) {
                            this.setState({management:false},()=>{
                                this.getList()
                            })
                        }
                    }
                });

        })

    }
    BatchImport(){
        this.request({
            url: "/cm-sites-storage-management/zykManage/exportExcelTemplate",
            method: "downloadGet",
            contentType: "json",
            callBack: (data) => {
                if(data) {
                    message.success("导入模板成功");
                }
            }
        });
    }
    handleChange(value) {
     this.setState({existManagerFlag:value,page:1},()=>{
         this.getList()
     })
    }
    renderData() {
        let columns=[
            {
                title: '单位',
                dataIndex: 'deptName',
                ellipsis:true,
                width:"25%",
            },
            {
                title: '单位管理员',
                dataIndex: 'deptManageNameList',
                ellipsis: true,
                width:"40%",
                    render: (text, record) => {
                        let data =text&&text.length?text.join('，'):'';
                    return(
                        <div title={data}  className={'twoText'}>{text&&text.length?text.join('，'):''}</div>
                    )
                }
            },
            {
                title: '最新修改时间',
                dataIndex: 'updateTime',
                width:"20%",
                render: (text, record) => {
                    return (<div>{formatTime(text)}</div>)
                }
            },
            {
                title: '操作',
                render: (text, record) => {
                    let newSecondSelectColor =this.sysConfigGetValueByKey("newSecondSelectColor", "#0050B3")
                    return (<div style={{color: newSecondSelectColor,}}><span style={{cursor: "pointer"}}
                            onClick={() => {
                                 this.Setting (record);

                    }}>设置管理</span>
                    </div>)
                }
            }
        ];
        return (
            <PageTableComponent columns={columns}
                                rowSelection={null}
                                data={this.state.data}
                                page={this.state.page}
                                size={this.state.size}
                                count={this.state.count}
                                onChangePage={(page, size)=>{
                                    this.onChangePage(page, size)
                                }}
            ></PageTableComponent>
        )
    }
    Setting(record){
        this.request({
            url: "/cm-sites-storage-management/zykManage/getById",
            method: "get",
            body: {id:record.id},
            contentType: "json",
            callBack: (data) => {
                if(data){
                    this.state.currentId= record.id;
                    this.state.departName = record.deptName;
                    this.state.currentObj =record;
                    this.state.peopleList =data.deptAccountArray;
                    this.state.management = true;
                    this.setState({});
                    if(data&&data.userArray&&data.userArray.length){
                        this.CandidateComponents.setCheckedKeys(data.userArray)
                    }

                }
            }
        });

    }
    onChangePage(page, size) {
        this.setState({page: page, size: size}, () => {
            this.getList()
        })
    }
    getList() {
        let parms ={};
        if(this.state.deptName){
            parms.deptName=this.state.deptName
        }
        if(this.state.existManagerFlag ){
            parms.typeSelection = this.state.existManagerFlag
        }
        this.request({
            url: "/cm-sites-storage-management/zykManage/pageList?page=" + this.state.page + '&size=' + this.state.size,
            method: "post",
            body: parms,
            contentType: "json",
            callBack: (data) => {
                if(data){
                    this.setState({data: data.data, count: data.count},()=>{
                        $('.ant-pagination-options-quick-jumper').find('input').val('')
                    });
                }
            }
        });

    };


}